import { useQuery } from "@tanstack/react-query";
import { getPages } from "../../api/apiPages";
import i18next from "i18next";

export const useGetPages = (params) => {
    const {
        data,
        isLoading,
        error,
        refetch
    } = useQuery({
        queryKey: ['pages', params, i18next.language],
        queryFn: () => getPages(params),
        retry: false,
    });

    const pages = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params.per_page || 10, total: 0 };

    return { pages, meta, isLoading, error, refetch };
};
